import { Action, Store } from '@ngrx/store';


export enum EMLOActions {
    GetAllMLOs = '[MLO] Get All MLO',
    GetAllMLODetails = '[MLO] Set All MLO Details',
    AddMLO = '[MLO] Add MLO',
    EditMLO = '[MLO] Edit MLO',
    SetMLOSuccess = 'Set MLO Success',
    SetMLOError = 'Set MLO Error',
    GetMLOInternalCode = '[MLO] Get MLO Internal Code',
    GetMLOInternalCodeSuccess = '[MLO] Get MLO Internal Code Success',
    InactivateMLC = "[MLO] Inactivate MLC",
    InactivateMLCSuccess = "[MLO] Inactivate MLC Success",
    StartMLC = "[MLO] Start MLC",
    StartMLCSuccess = "[MLO] Start MLC Success",
    CloseMLC = "[MLO] Close MLC",
    CloseMLCSuccess = "[MLO] Close MLC Success",
    GetAllOlderMlcs = "[MLO] Get All Older MLCs",
    GetAllOlderMlcsSuccess = "[MLO] Get All Older MLCs Success",
    GetAllOlderMlcsError = "[MLO] Get All Older MLCs Error",
    GetMLCById = "[MLC] Get MLC By Id",
    SetMLCByIdSuccess = "[MLC] Set MLC By Id Success",
    SetMLCByIdError = "[MLC] Set MLC By Id Error",
    GetAllClosedMlcs = "[MLC] Get All Closed MLCs",
    GetAllClosedMlcsSuccess = "[MLC] Get All Closed MLCs Success",
    GetAllClosedMlcsError = "[] Get All Closed MLCs Error",
    GetClosedMlcById = "[MLC] Get Closed MLCs By Id",
    GetClosedMlcByIdSuccess = "[MLC] Get Closed MLCs By Id Success",
    GetClosedMlcByIdError = "[] Get Closed MLCs By Id Error",
    ActivateMLC = "[MLC] Activate Closed MLC",
    GetActivateMLCSuccess = "[MLC] Get Activate Closed MLC Success",
    GetActivateMLCError = "[] Get Activate Closed MLC Error",
    EditClosedMlcs = "[MLC] Edit Closed MLCs",
    GetEditClosedMlcsSuccess = "[MLC] Get Edit Closed MLCs Success",
    GetEditClosedMlcsError = "[] Get Edit Closed MLCs Error",
    GetMLCByIdWithReleaseData = "[MLC] Get MLC By Id With ReleaseData",
    SetMLCByIdWithReleaseDataSuccess = "[MLC] Set MLC By Id With Releasedata Success",
    SetMLCByIdWithReleaseDataError = "[MLC] Set MLC By Id With Releasedata Error",
    GetFormulaAndMlc = "[MLC] Get Formula and Mlc",
    GetFormulaAndMlcSuccess = "[MLC] Get Formula and Mlc Success",
    GetFormulaAndMlcError = "[] Get Formula and Mlc Error",
    GetFormulaByIdForReleaseData = "[MLC] Get Formula By Id For Release data",
    GetFormulaByIdForReleaseDataSuccess= "[MLC] Get Formula By Id For Release data Success",
    GetFormulaByIdForReleaseDataError= "[] Get Formula By Id For Release data Error",
    //mail
    SendMailWhenCreateMLC = '[MLC] send Mail When Create MLC',
    GetSendMailWhenCreateMLCSuccess = '[MLC] Get send Mail When Create MLC Success',
    GetSendMailWhenCreateMLCError = '[] Get send Mail When Create MLC Error',

    SendMailtoWarehouseUsers = '[MLC] send Mail to Warehouse Users',
    GetSendMailtoWarehouseUsersSuccess = '[MLC] Get send Mail to Warehouse Users Success',
    GetSendMailtoWarehouseUsersError = '[] Get send Mail to Warehouse Users Error',

    GetCloseMlcUserAction = '[MLC] Get Close Mlc UserAction',
    GetCloseMlcUserActionSuccess = '[MLC] Get Close Mlc UserAction Success',
    GetCloseMlcUserActionError = '[] Get Close Mlc UserAction Error',
}

export class GetAllMLOs implements Action {
    public readonly type = EMLOActions.GetAllMLOs;
    constructor(public payload: any) {}
}

export class GetAllMLODetails implements Action {
    public readonly type = EMLOActions.GetAllMLODetails;
    constructor(public payload: any) {
    }
}

export class AddMLO implements Action {
    public readonly type = EMLOActions.AddMLO;
    constructor(public payload: any) {
    }
}
export class EdtMLO implements Action {
    public readonly type = EMLOActions.EditMLO;
    constructor(public payload: any) {
    }
}

export class SetMLOSuccess implements Action {
    public readonly type = EMLOActions.SetMLOSuccess;
    constructor(public payload: any, public store: any) {
    }
}

export class SetMLOError implements Action {
    public readonly type = EMLOActions.SetMLOError;
    constructor(public payload: any) {
    }
}

export class GetMLOInternalCode implements Action {
    public readonly type = EMLOActions.GetMLOInternalCode;
    constructor(public payload: any) {
    } 
}

export class GetMLOInternalCodeSuccess implements Action {
    public readonly type = EMLOActions.GetMLOInternalCodeSuccess;
    constructor(public payload: any) {
    } 
}

export class InactivateMLC implements Action {
    public readonly type = EMLOActions.InactivateMLC;
    constructor(public payload : any) {}
}
export class InactivateMLCSuccess implements Action {
    public readonly type = EMLOActions.InactivateMLCSuccess;
    constructor(public payload : any) {}
}
export class StartMLC implements Action {
    public readonly type = EMLOActions.StartMLC;
    constructor(public payload : any) {}
}
export class StartMLCSuccess implements Action {
    public readonly type = EMLOActions.StartMLCSuccess;
    constructor(public payload : any) {}
}
export class CloseMLC implements Action {
    public readonly type = EMLOActions.CloseMLC;
    constructor(public payload : any) {}
}
export class CloseMLCSuccess implements Action {
    public readonly type = EMLOActions.CloseMLCSuccess;
    constructor(public payload : any) {}
}

export class GetAllOlderMlcs implements Action {
    public readonly type = EMLOActions.GetAllOlderMlcs;
    constructor(public payload : any) {}
}
export class GetAllOlderMlcsSuccess implements Action {
    public readonly type = EMLOActions.GetAllOlderMlcsSuccess;
    constructor(public payload : any) {}
}
export class GetAllOlderMlcsError implements Action {
    public readonly type = EMLOActions.GetAllOlderMlcsError;
    constructor(public payload : any) {}
}
export class GetMLCById implements Action {
    public readonly type = EMLOActions.GetMLCById;
    constructor(public payload : any) {}
}
export class SetMLCByIdSuccess implements Action {
    public readonly type = EMLOActions.SetMLCByIdSuccess;
    constructor(public payload : any) {}
}
export class SetMLCByIdError implements Action {
    public readonly type = EMLOActions.SetMLCByIdError;
    constructor(public payload : any) {}
}
export class GetAllClosedMlcs implements Action {
    public readonly type = EMLOActions.GetAllClosedMlcs;
    constructor(public payload : any) {}
}
export class GetAllClosedMlcsSuccess implements Action {
    public readonly type = EMLOActions.GetAllClosedMlcsSuccess;
    constructor(public payload : any) {}
}
export class GetAllClosedMlcsError implements Action {
    public readonly type = EMLOActions.GetAllClosedMlcsError;
    constructor(public payload : any) {}
}
export class GetClosedMlcById implements Action {
    public readonly type = EMLOActions.GetClosedMlcById;
    constructor(public payload : any) {}
}
export class GetClosedMlcByIdSuccess implements Action {
    public readonly type = EMLOActions.GetClosedMlcByIdSuccess;
    constructor(public payload : any) {}
}
export class GetClosedMlcByIdError implements Action {
    public readonly type = EMLOActions.GetClosedMlcByIdError;
    constructor(public payload : any) {}
}
export class ActivateMLC implements Action {
    public readonly type = EMLOActions.ActivateMLC;
    constructor(public payload : any) {}
}
export class GetActivateMLCSuccess implements Action {
    public readonly type = EMLOActions.GetActivateMLCSuccess;
    constructor(public payload : any) {}
}
export class GetActivateMLCError implements Action {
    public readonly type = EMLOActions.GetActivateMLCError;
    constructor(public payload : any) {}
}
export class EditClosedMlcs implements Action {
    public readonly type = EMLOActions.EditClosedMlcs;
    constructor(public payload : any) {}
}
export class GetEditClosedMlcsSuccess implements Action {
    public readonly type = EMLOActions.GetEditClosedMlcsSuccess;
    constructor(public payload : any) {}
}
export class GetEditClosedMlcsError implements Action {
    public readonly type = EMLOActions.GetEditClosedMlcsError;
    constructor(public payload : any) {}
}
export class GetMLCByIdWithReleaseData implements Action {
    public readonly type = EMLOActions.GetMLCByIdWithReleaseData;
    constructor(public payload : any) {}
}
export class SetMLCByIdWithReleaseDataSuccess implements Action {
    public readonly type = EMLOActions.SetMLCByIdWithReleaseDataSuccess;
    constructor(public payload : any) {}
}
export class SetMLCByIdWithReleaseDataError implements Action {
    public readonly type = EMLOActions.SetMLCByIdWithReleaseDataError;
    constructor(public payload : any) {}
}
export class GetFormulaAndMlc implements Action {
    public readonly type = EMLOActions.GetFormulaAndMlc;
    constructor(public payload : any) {}
}
export class GetFormulaAndMlcSuccess implements Action {
    public readonly type = EMLOActions.GetFormulaAndMlcSuccess;
    constructor(public payload : any) {}
}
export class GetFormulaAndMlcError implements Action {
    public readonly type = EMLOActions.GetFormulaAndMlcError;
    constructor(public payload : any) {}
}
export class GetFormulaByIdForReleaseData implements Action {
    public readonly type = EMLOActions.GetFormulaByIdForReleaseData;
    constructor(public payload : any) {}
}
export class GetFormulaByIdForReleaseDataSuccess implements Action {
    public readonly type = EMLOActions.GetFormulaByIdForReleaseDataSuccess;
    constructor(public payload : any) {}
}
export class GetFormulaByIdForReleaseDataError implements Action {
    public readonly type = EMLOActions.GetFormulaByIdForReleaseDataError;
    constructor(public payload : any) {}
}
export class SendMailWhenCreateMLC implements Action {
    public readonly type = EMLOActions.SendMailWhenCreateMLC;
    constructor(public payload : any) {}
}
export class GetSendMailWhenCreateMLCSuccess implements Action {
    public readonly type = EMLOActions.GetSendMailWhenCreateMLCSuccess;
    constructor(public payload : any) {}
}
export class GetSendMailWhenCreateMLCError implements Action {
    public readonly type = EMLOActions.GetSendMailWhenCreateMLCError;
    constructor(public payload : any) {}
}
export class SendMailtoWarehouseUsers implements Action {
    public readonly type = EMLOActions.SendMailtoWarehouseUsers;
    constructor(public payload : any) {}
}
export class GetSendMailtoWarehouseUsersSuccess implements Action {
    public readonly type = EMLOActions.GetSendMailtoWarehouseUsersSuccess;
    constructor(public payload : any) {}
}
export class GetSendMailtoWarehouseUsersError implements Action {
    public readonly type = EMLOActions.GetSendMailtoWarehouseUsersError;
    constructor(public payload : any) {}
}

export class GetCloseMlcUserAction implements Action {
    public readonly type = EMLOActions.GetCloseMlcUserAction;
    constructor(public payload : any) {
    }
}
export class GetCloseMlcUserActionSuccess implements Action {
    public readonly type = EMLOActions.GetCloseMlcUserActionSuccess;
    constructor(public payload : any) {
    }
}
export class GetCloseMlcUserActionError implements Action {
    public readonly type = EMLOActions.GetCloseMlcUserActionError;
    constructor(public payload : any) {}
}
export type MLOAction =  GetAllMLOs | GetAllMLODetails | AddMLO | EdtMLO | SetMLOSuccess | SetMLOError
                            | GetMLOInternalCode | GetMLOInternalCodeSuccess | InactivateMLC |
                            InactivateMLCSuccess | StartMLC | StartMLCSuccess | CloseMLC | CloseMLCSuccess | GetAllOlderMlcs|
                            GetAllOlderMlcsSuccess| GetAllOlderMlcsError | GetMLCById | SetMLCByIdSuccess | SetMLCByIdError
                            |GetAllClosedMlcs|GetAllClosedMlcsSuccess|GetAllClosedMlcsError|GetClosedMlcById|
                            GetClosedMlcByIdSuccess|GetClosedMlcByIdError|ActivateMLC| GetActivateMLCSuccess| GetActivateMLCError |EditClosedMlcs|
                            GetEditClosedMlcsSuccess|GetEditClosedMlcsError | GetMLCByIdWithReleaseData | 
                            SetMLCByIdWithReleaseDataSuccess | SetMLCByIdWithReleaseDataError|
                            GetFormulaAndMlc|GetFormulaAndMlcSuccess|GetFormulaAndMlcError|GetFormulaByIdForReleaseData|
                            GetFormulaByIdForReleaseDataSuccess|GetFormulaByIdForReleaseDataError| SendMailWhenCreateMLC|GetSendMailWhenCreateMLCSuccess|
                            GetSendMailWhenCreateMLCError | SendMailtoWarehouseUsers| GetSendMailtoWarehouseUsersSuccess|GetSendMailtoWarehouseUsersError|
                            GetCloseMlcUserAction|GetCloseMlcUserActionSuccess|GetCloseMlcUserActionError;